var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLogs24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_logs24x24",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(3 4)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M96.667,32.222v3.431h2.275V34.507h10.236V45.934H98.942v-1.14H96.667v3.428h14.786v-16Z",
    transform: "translate(-93.453 -32.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M5.227,145.564l1.515,1.705,3.972-4.47-3.972-4.471-1.515,1.705,1.386,1.557H0V144H6.613Z",
    transform: "translate(0 -134.801)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLogs24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_logs24x24.c07bec43c1b76474bf9bafd541a622e7.svg";